'use client';

import { useEffect } from 'react';
import { useAppStore } from '@/store/app';

/**
 * Page-level auth gate for login-required pages (signals / on-chain / research).
 * - 'checking' / 'expired': returns false (render nothing, no flash of content).
 * - 'guest' (no user): redirects to /login?redirect=<path> once, returns false.
 * - 'authenticated': returns true.
 */
export function useRequireAuth(redirectPath: string, allowGuest = false): boolean {
  const user = useAppStore((s) => s.user);
  const authState = useAppStore((s) => s.authState);

  useEffect(() => {
    if (!allowGuest && authState === 'guest' && !user) {
      window.location.href = `/login?redirect=${encodeURIComponent(redirectPath)}`;
    }
  }, [authState, user, redirectPath, allowGuest]);

  return authState === 'authenticated' && !!user;
}
